import React from "react";

const SectionHeading = ({ eyebrow, title, subtitle, align = "left", className = "" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}>
    {eyebrow && <p className="mise-eyebrow mb-4">{eyebrow}</p>}
    <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.1]">
      {title}
    </h2>
    {subtitle && <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">{subtitle}</p>}
  </div>
);

export default SectionHeading;
